import React, { useState, useEffect } from 'react';
import './Navigation.css';
import { domId } from '../../utils/domIds';
import { seccionDisponible } from '../../utils/countryUtils';

const PAGINAS = [
  { id: 'top',        name: 'Top Ofertas', icon: '🔥', description: 'Los mayores descuentos hoy' },
  { id: 'todos',      name: 'Explorar',    icon: '🛍️', description: 'Todos los productos' },
  { id: 'viajes',     name: 'Viajes',      icon: '✈️', description: 'Ofertas de vuelos y hoteles' },
  { id: 'exclusivos', name: 'Exclusivos',  icon: '⭐', description: 'Ofertas de tienda exclusivas para registrados' },
  { id: 'tracking',   name: 'Alertas',     icon: '🔔', description: 'Mis alertas y seguimiento' },
];

const Navigation = ({ currentPage, onPageChange, country }) => {
  const [visible, setVisible] = useState(true);
  const [lastY, setLastY] = useState(0);

  // Viajes depende de una fuente que sólo existe en Argentina, así que en
  // España no se muestra. Exclusivos sí está en los dos países desde que
  // España tiene su propio catálogo. Ver `SECCIONES_SOLO_AR` en countryUtils.
  const pages = PAGINAS.filter(p => seccionDisponible(p.id, country));

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY;
      setVisible(y < 80 || y < lastY);
      setLastY(y);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [lastY]);

  return (
    <div id="nav-principal" className={`navigation-container ${visible ? 'nav-visible' : 'nav-hidden'}`}>
      <div id="nav-wrapper" className="navigation-wrapper">
        <ul id="nav-tabs" className="tab-navigation" role="tablist">
          {pages.map(page => (
            <li
              key={page.id}
              id={domId('nav-item', page.id)}
              className={`tab-item ${currentPage === page.id ? 'active' : ''}`}
              role="presentation"
            >
              <button
                id={domId('nav-link', page.id)}
                onClick={() => onPageChange(page.id)}
                className="tab-link"
                role="tab"
                aria-selected={currentPage === page.id}
                data-tooltip={page.description}
              >
                {/* Un solo icono: en móvil crece y el rótulo se oculta por CSS.
                    Antes había un segundo span con el mismo emoji para la
                    versión móvil, y como el primero no se ocultaba, se veían
                    los dos. */}
                <span className="tab-icon">{page.icon}</span>
                <span className="tab-text">{page.name}</span>
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Navigation;
